import React, { Component } from 'react';
import EventsScreen from './EventsScreen'


function EventMainScreen () {
  
    return (
      <div>
          
       
      <EventsScreen />
       
      
      </div>
    );
  
}

export default EventMainScreen;